import { Card } from '@oacore/design'

import CardFooter from './footer'

Card.Footer = CardFooter

export default Card
